import { calculateTimerColor } from "utils/timer";
import "./index.scss";

export const ProgressBar = ({ seconds }) => {
  const MAX_TIME = 600;

  const calculateProgress = () => (100 * seconds) / MAX_TIME;

  return (
    <div className="progress-bar">
      <div
        className="bar"
        style={{
          width: `${calculateProgress()}%`,
          background: calculateTimerColor(seconds)
        }}
      />
    </div>
  );
};
